import { CommonScriptComponent } from './../common-script/common-script.component';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprise-solutions',
  templateUrl: './enterprise-solutions.component.html',
  styleUrls: ['./enterprise-solutions.component.css']
})
export class EnterpriseSolutionsComponent implements OnInit {

  constructor(private commonScriptComponent: CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/enterprise-solutions/enterprise-solutions.component.ts